import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GraylogLogoComponent } from './graylog-logo/graylog-logo.component';
import { HomerLogoComponent } from './homer-logo/homer-logo.component';

@NgModule({
   declarations: [GraylogLogoComponent, HomerLogoComponent],
   imports: [CommonModule],
   exports: [GraylogLogoComponent, HomerLogoComponent],
})
export class IconsModule {}
